import { DocumentationType } from "../../components/Utils/DocumentationUtils";
import * as SearchConstant from "../../components/Constants/SearchConstant";

export { DocumentationType };

export const getSearchIndex = (indexKeyName, keepSts = false) => {
    const foundIndexes = Object.keys(SearchConstant.SearchIndexPaths).filter(key => {
        let keepKey = true;

        const endsWithSts = key.toLowerCase().endsWith(DocumentationType.Sts);
        keepKey = keepSts ? endsWithSts : !endsWithSts;
        if (keepKey)
            keepKey = key.toLowerCase().startsWith(indexKeyName.toLowerCase());
        return keepKey;
    });
    return foundIndexes;
}
